import { render, staticRenderFns } from "./FaqNew.vue?vue&type=template&id=1476d40c&scoped=true"
import script from "./FaqNew.vue?vue&type=script&lang=js"
export * from "./FaqNew.vue?vue&type=script&lang=js"
import style0 from "./FaqNew.vue?vue&type=style&index=0&id=1476d40c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1476d40c",
  null
  
)

export default component.exports